import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

// Almost every date the API returns is an instant, not a calendar day —
// createdAt, a jackpot draw date, a match kickoff. Render those in the viewer's
// own timezone. Reading the UTC day off the string instead moves the date back
// by one for every record that lands on the far side of midnight locally (at
// UTC+5:30 that is anything from 00:00 to 05:29 local).
export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

// For the few fields that really are a calendar day — a date of birth, a season
// start — where the day itself is the value and must read the same everywhere.
// Takes the day straight off the ISO string so no offset can shift it.
export function fDateOnly(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  if (!date) return '';

  const isoDateOnly = String(date).split('T')[0]; // Get '2025-07-04'
  const fixedDate = new Date(isoDateOnly + 'T00:00:00'); // Avoid timezone shift

  return format(fixedDate, fm);
}

// The name a dozen call sites already use for timezone-aware formatting.
export const fDate1 = fDate;

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function isSameUTCDate(dateStr) {
  if (!dateStr) return false;

  const winDateUTC = new Date(dateStr);
  const todayUTC = new Date();

  // Get both in UTC yyyy-mm-dd format
  const winDateString = winDateUTC.toISOString().split('T')[0];
  const todayDateString = todayUTC.toISOString().split('T')[0];

  return winDateString === todayDateString;
}


